var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesIconInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 3.75H15H10C7.92894 3.75 6.25 5.42894 6.25 7.5V22.5C6.25 24.5711 7.92894 26.25 10 26.25H13.75M16.875 3.75L23.75 10.7812M16.875 3.75V9.53125C16.875 10.2216 17.4346 10.7812 18.125 10.7812H23.75M23.75 10.7812V14.7656",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 18.75V22.5M21.25 22.5V26.25M21.25 22.5H17.5M21.25 22.5H25",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesIconInput);
export default __webpack_public_path__ + "static/media/files_icon-input.dd54932df38f567a857f91320331ffd1.svg";
export { ForwardRef as ReactComponent };